Vue.asyncComponent('bp-grid-row', {
    props: {
        previewMode: {
            type: Boolean,
            required: false,
            default: false
        },
    },
}, 'blueprints/editor/grid/bp-grid-row.html');